export const externalBaseUrl = process.env.REACT_APP_EXTERNAL_URL;
